import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { it } from './it';
import { en } from './en';

export type Lingua = 'it' | 'en';

export const LINGUE: readonly Lingua[] = ['it', 'en'];

void i18next.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
  },
  lng: 'it',
  fallbackLng: 'it',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export const i18n = i18next;

export function localeDi(lingua: string): string {
  return lingua === 'en' ? 'en-GB' : 'it-IT';
}
